module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/banco-itau-logo-6a45f03203cb88167e2de63302fb88ec.svg";